// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1352t","obliqueLineWrap":"membershipbadge_obliqueLineWrap__UUWJG","obliqueLine":"membershipbadge_obliqueLine__1eamO"};